import {createFileRoute, notFound} from "@tanstack/react-router";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart")({
    beforeLoad: async ({context, params}) => {
        const workspaceIdResult = uuidZodValidator.safeParse(params.workspaceId);
        if (workspaceIdResult.success !== true) {
            throw notFound();
        }
        const workspaceId = workspaceIdResult.data;

        if (context.workspace.id !== workspaceId) {
            throw notFound();
        }

    },
    loader: async () => {},
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
